import { render, staticRenderFns } from "./PackageRegistrationDetail.vue?vue&type=template&id=015e5e4d&scoped=true"
import script from "./PackageRegistrationDetail.vue?vue&type=script&lang=js"
export * from "./PackageRegistrationDetail.vue?vue&type=script&lang=js"
import style0 from "./PackageRegistrationDetail.vue?vue&type=style&index=0&id=015e5e4d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015e5e4d",
  null
  
)

export default component.exports